import { render } from "./Assemblies.vue?vue&type=template&id=4992bd83&scoped=true"
import script from "./Assemblies.vue?vue&type=script&lang=js"
export * from "./Assemblies.vue?vue&type=script&lang=js"

import "./Assemblies.vue?vue&type=style&index=0&id=4992bd83&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4992bd83"

export default script